export enum CampaignType {
  AUTOMATED_BIRTHDAY = "automated_birthday",
  AUTOMATED_HOME_ANNIVERSARY = "automated_home_anniversary",
  NO_GIFT = "no_gift",
  POSTCARD = "postcard",
  GIFT = "gift",
}

export enum DeliveryMethod {
  SMS = "sms",
  EMAIL = "email",
  SMS_AND_EMAIL = "sms_and_email",
}

export enum CampaignFrequency {
  ONCE = "once",
  QUARTERLY = "quarterly",
  HALF_YEARLY = "half_yearly",
  YEARLY = "yearly",
  EVERY_2_YEARS = "every_2_years",
  EVERY_3_YEARS = "every_3_years",
  EVERY_4_YEARS = "every_4_years",
  EVERY_5_YEARS = "every_5_years",
}

export interface CampaignRecipient {
  recipient_id?: string;
  campaign_id?: string;
  name: string;
  email: string;
  mobile: string;
  gift_type?: string;
  price_id: string;
  is_active?: boolean;
  is_delete?: boolean;
  event_date?: string; // ISO date string
  trigger_date?: string; // ISO date string
  last_sent_on?: string | null;
  sent_count?: number;
  created_at?: string;
  updated_at?: string;
  price?: {
    price_id: string;
    order_price: number;
    is_default: boolean;
    gift_types: string;
  };
}

export interface Campaign {
  campaign_id: string;
  campaign_name: string;
  user_id: string;
  campaign_type: CampaignType;
  frequency?: CampaignFrequency;
  gift_type: string;
  price_id: string;
  email_template_id?: string;
  subject?: string;
  email_template_body?: string;
  delivery_method?: DeliveryMethod;
  sms_content?: string;
  days_before_event?: number;
  is_active: boolean;
  is_delete: boolean;
  handwritten_note?: string;
  occasion_id?: string;
  occasion?: {
    occasion_id: string;
    name: string;
  };
  recipient_list?: CampaignRecipient[];
  created_at: string;
  updated_at: string;
  price?: {
    price_id: string;
    order_price: number;
    is_default: boolean;
    gift_types: string;
  };
  email_template?: {
    email_template_id: string;
    name?: string;
    title?: string;
    subject: string;
    body: string;
    occasion_id?: string;
    occasion?: {
      occasion_id: string;
      name: string;
    };
  };
  user?: {
    user_id: string;
    first_name: string;
    last_name: string;
    email: string;
  };
}

export interface CreateCampaignDto {
  campaign_type: CampaignType;
  frequency?: CampaignFrequency;
  gift_type?: string;
  price_id?: string;
  campaign_name: string;
  email_template_id?: string;
  occasion_id?: string;
  subject?: string;
  email_template_body?: string;
  delivery_method?: DeliveryMethod;
  sms_content?: string;
  days_before_event?: number;
  is_active?: boolean;
  handwritten_note?: string;
  recipient_list: CreateCampaignRecipientDto[];
}

export interface CreateCampaignRecipientDto {
  name: string;
  email: string;
  mobile: string;
  gift_type?: string;
  price_id?: string;
  is_active?: boolean;
  event_date?: string; // ISO date string
  trigger_date?: string; // ISO date string
}

export interface UpdateCampaignDto extends Partial<CreateCampaignDto> { }

